import { useDashboardControls } from 'contexts/Dashboard/useDashboardControls';
import DashboardWidgetsWrapper from 'components/Dashboard/WidgetWrapper';
import { TLWidgetsEnum } from './utils';
import { memo } from 'react';
import { WidgetConfig } from 'components/Dashboard/types';
import FTsOnStandbyWidget from './widgets/FTsOnStandbyWidget';
import PlaceholderAssignmentsWidget from './widgets/PlaceholderAssignmentsWidget';
import MissingExpectedExpensesWidget from './widgets/MissingExpectedExpensesWidget';
import IncompleteDayPlanWidget from './widgets/IncompleteDayPlanTomorrowWidget';
import RejectedOrUnapprovedAssignmentRequestsWidget from './widgets/RejectedOrUnapprovedAssignmentRequestsWidget';
import CommentsWidget from './widgets/CommentsWidget';
import FaultyCarWidget from './widgets/FaultyCarWidget';
import BookedToEditedByFTWidget from './widgets/BookedToEditedByFTWidget';
import DeviationReportsWidget from './widgets/DeviationReportsWidget';
import NotAcceptedTomorrowsAssignmentsWidget from './widgets/NotAcceptedTomorrowsAssignmentsWidget';
import BookedToTimePassedWidget from './widgets/BookedToTimePassedWidget';
import EstimatedEndTimePassedWidget from './widgets/EstimatedEndTimePassedWidget';
import EstimatedStartTimePassedWidget from './widgets/EstimatedStartTimePassedWidget';
import WorkGearReportsWidget from './widgets/WorkGearReportsWidget';
import FlaggedForSpeedingWidget from './widgets/FlaggedForSpeedingWidget';
import NotLoadedTyresWidget from './widgets/NotLoadedTyresWidget';
import AssignmentRescheduledToAfterMidnightWidget from './widgets/AssignmentRescheduledToAfterMidnightWidget';
import StandbyTimeAssignmentsWidget from './widgets/StandbyTimeAssignmentsWidget';
import HotelBookedYesterdayWidget from './widgets/HotelBookedYesterdayWidget';

const widgetConfigTransportLogistics: WidgetConfig<TLWidgetsEnum>[] = [
  {
    widgetType: TLWidgetsEnum.FTsOnStandby,
    component: memo(FTsOnStandbyWidget),
  },
  {
    widgetType: TLWidgetsEnum.PlaceholderAssignments,
    component: memo(PlaceholderAssignmentsWidget),
  },
  {
    widgetType: TLWidgetsEnum.MissingExpectedExpenses,
    component: memo(MissingExpectedExpensesWidget),
  },
  {
    widgetType: TLWidgetsEnum.IncompleteDayPlan,
    component: memo(IncompleteDayPlanWidget),
  },
  {
    widgetType: TLWidgetsEnum.RejectedOrUnapprovedAssignmentRequests,
    component: memo(RejectedOrUnapprovedAssignmentRequestsWidget),
  },
  {
    widgetType: TLWidgetsEnum.FaultyCar,
    component: memo(FaultyCarWidget),
  },
  {
    widgetType: TLWidgetsEnum.Comments,
    component: memo(CommentsWidget),
  },
  {
    widgetType: TLWidgetsEnum.DeviationReports,
    component: memo(DeviationReportsWidget),
  },
  {
    widgetType: TLWidgetsEnum.BookedToEditedByFT,
    component: memo(BookedToEditedByFTWidget),
  },
  {
    widgetType: TLWidgetsEnum.NotAcceptedTomorrowsAssignments,
    component: memo(NotAcceptedTomorrowsAssignmentsWidget),
  },
  {
    widgetType: TLWidgetsEnum.EstimatedStartTimePassed,
    component: memo(EstimatedStartTimePassedWidget),
  },
  {
    widgetType: TLWidgetsEnum.EstimatedEndTimePassed,
    component: memo(EstimatedEndTimePassedWidget),
  },
  {
    widgetType: TLWidgetsEnum.BookedToTimePassed,
    component: memo(BookedToTimePassedWidget),
  },
  {
    widgetType: TLWidgetsEnum.WorkGearReports,
    component: memo(WorkGearReportsWidget),
  },
  {
    widgetType: TLWidgetsEnum.FlaggedForSpeeding,
    component: memo(FlaggedForSpeedingWidget),
  },
  {
    widgetType: TLWidgetsEnum.NotLoadedTyres,
    component: memo(NotLoadedTyresWidget),
  },
  {
    widgetType: TLWidgetsEnum.AssignmentRescheduledToAfterMidnight,
    component: memo(AssignmentRescheduledToAfterMidnightWidget),
  },
  {
    widgetType: TLWidgetsEnum.StandbyTimeAssignments,
    component: memo(StandbyTimeAssignmentsWidget),
  },
  {
    widgetType: TLWidgetsEnum.HotelBookedYesterday,
    component: memo(HotelBookedYesterdayWidget),
  },
];

const DashboardTransportLogistics = () => {
  const {
    dashboardState: { widgets },
  } = useDashboardControls();
  const getIsActive = (widgetType: TLWidgetsEnum) => {
    return widgets.some(
      (w) => w.identifier === widgetType && w.active === true
    );
  };

  return (
    <DashboardWidgetsWrapper>
      {widgetConfigTransportLogistics.map(
        ({ widgetType, component: Component }) =>
          getIsActive(widgetType) && <Component key={widgetType} />
      )}
    </DashboardWidgetsWrapper>
  );
};

export default DashboardTransportLogistics;
